'use strict';

var _fs = require('fs');

var _fs2 = _interopRequireDefault(_fs);

var _index = require('../index');

var _isObject = require('../isObject');

var _isObject2 = _interopRequireDefault(_isObject);

var _keys = require('../keys');

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Assert = require('assert');
var Lab = require('lab');
var Code = require('code');
var lab = exports.lab = Lab.script();
var expect = Code.expect;


lab.experiment('object-looper', function () {
  lab.test('will detect if the parameter is an object', function (done) {
    var obj = {
      key1: 'test',
      key2: 'test2'
    };
    expect((0, _isObject2.default)(obj)).to.be.true();
    expect((0, _isObject2.default)(null)).to.be.false();
    expect((0, _isObject2.default)([])).to.be.false();
    done();
  });
  lab.test('will give keys with keys function', function (done) {
    var obj = {
      key1: 'test',
      key2: 'test2'
    };
    expect((0, _keys2.default)(obj)[0]).to.equal('key1');
    done();
  });
  lab.test('will loop through an objects own keys', function (done) {
    var obj = {
      key1: 'test',
      key2: 'test2'
    };
    (0, _index.forEachKeys)(obj, function (key, value, index) {
      if (index === 0) {
        expect(value).to.equal('test');
      }
      if (index === 1) {
        expect(value).to.equal('test2');
      }
    });
    done();
  });
  lab.test('will loop through an objects own keys and will throw an error if the first parameter is not an object', function (done) {
    function throws() {
      (0, _index.forEachKeys)([], function (key, value, index) {});
    }
    expect(throws).to.throw(Error, 'first argument must be an object');
    done();
  });
  lab.test('will filter an object through its own keys', function (done) {
    var obj = {
      key1: 'test',
      key2: 'test2'
    };
    var filtered = (0, _index.filterKeys)(obj, function (key, value, index) {
      return value === 'test';
    });
    expect(filtered['key1']).to.equal('test');
    done();
  });
  lab.test('will filter an object through its own keys and will throw an error if the first parameter is not an object', function (done) {
    function throws() {
      (0, _index.filterKeys)([]);
    }
    expect(throws).to.throw(Error, 'first argument must be an object');
    done();
  });
  lab.test('will create a new object through mapping', function (done) {
    var obj = {
      key1: 'test',
      key2: 'test2'
    };
    var mapped = (0, _index.mapKeys)(obj, function (key, value, index) {
      return _defineProperty({}, key, value + 'map');
    });
    expect(mapped['key1']).to.equal('testmap');
    done();
  });
  lab.test('will create a new object through mapping and will throw an error if the first parameter is not an object', function (done) {
    function throws() {
      (0, _index.mapKeys)([]);
    }
    expect(throws).to.throw(Error, 'first argument must be an object');
    done();
  });
  lab.test('will test every element for truthyness with every', function (done) {
    var obj = {
      key1: 1,
      key2: 2
    };
    var isSmallEnough = (0, _index.everyKeys)(obj, function (key, value, index) {
      return value < 10;
    });
    expect(isSmallEnough).to.equal(true);
    var isBigEnough = (0, _index.everyKeys)(obj, function (key, value, index) {
      return value > 10;
    });
    expect(isBigEnough).to.equal(false);
    done();
  });
  lab.test('will test every element for truthyness with every and will throw an error if the first parameter is not an object', function (done) {
    function throws() {
      (0, _index.everyKeys)([]);
    }
    expect(throws).to.throw(Error, 'first argument must be an object');
    done();
  });
  lab.test('will test every element for truthyness with some', function (done) {
    var obj = {
      key1: 1,
      key2: 11
    };
    var isSmallEnough = (0, _index.someKeys)(obj, function (key, value, index) {
      return value < 10;
    });
    expect(isSmallEnough).to.equal(true);
    var isBigEnough = (0, _index.someKeys)(obj, function (key, value, index) {
      return value > 10;
    });
    expect(isSmallEnough).to.equal(true);
    done();
  });
  lab.test('will test every element for truthyness with some and will throw an error if the first parameter is not an object', function (done) {
    function throws() {
      (0, _index.someKeys)([]);
    }
    expect(throws).to.throw(Error, 'first argument must be an object');
    done();
  });
  lab.test('will reduce the keys values with reduce', function (done) {
    var obj = {
      key1: 1,
      key2: 11
    };
    var result = (0, _index.reduceKeys)(obj, function (prevKey, prevValue, currKey, currValue, index) {
      return prevValue + currValue;
    });
    expect(result).to.equal(12);
    done();
  });
  lab.test('will reduce the keys values with reduce and will throw an error if the first parameter is not an object', function (done) {
    function throws() {
      (0, _index.reduceKeys)([]);
    }
    expect(throws).to.throw(Error, 'first argument must be an object');
    done();
  });
  lab.test('will find a key with find', function (done) {
    var obj = {
      key1: 1,
      key2: 11
    };
    var result = (0, _index.findKeys)(obj, function (key, value, index) {
      return value === 1;
    });
    expect(result.key1).to.equal(1);
    done();
  });
  lab.test('will find a key with find and will throw an error if the first parameter is not an object', function (done) {
    function throws() {
      (0, _index.findKeys)([]);
    }
    expect(throws).to.throw(Error, 'first argument must be an object');
    done();
  });
  lab.test('will return undefined when find a key with find fails', function (done) {
    var obj = {
      key1: 1,
      key2: 11
    };
    var result = (0, _index.findKeys)(obj, function (key, value, index) {
      return value === 45;
    });
    expect(result).to.equal(undefined);
    done();
  });
});
//# sourceMappingURL=object-looper.js.map